import { API } from "../../constAPI";

const jsonHeaders = (token) => ({
  Authorization: `token ${token}`,
  Accept: "application/json",
  "Content-type": "application/json",
});

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const message = data?.error || data?.message || data?.errors?.join(", ") || "Request failed";
    throw new Error(message);
  }
  return data;
};

const withParams = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, value);
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const getMatchNeeds = (filters, token) => (
  fetch(`${API}/api/admin/match-needs${withParams(filters)}`, {
    headers: jsonHeaders(token),
  }).then(parseResponse)
);
